import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import Utils from 'src/utils/Utils';
import { toRaw } from 'vue';
import logger from 'src/utils/logger';
class DeviceClass {
    $q;
    constructor() {
        this.$q = useQuasar();
    }
    enrichHostname(data, props) {
        if (!data.hostname && props.columns) {
            data.hostname = props.columns.hostname;
        }
        else if (!data.hostname && props.infoApp) {
            data.hostname = props.infoApp.network_config?.hostname;
        }
    }
    enrichPools(data) {
        if (data.pools) {
            data.pools.forEach((pool, index) => {
                data[`pool_${index + 1}`] = pool.url;
                data[`worker_${index + 1}`] = pool.user;
            });
        }
        else {
            for (let i = 1; i <= 3; i++) {
                data[`pool_${i}`] = '';
                data[`worker_${i}`] = '';
            }
        }
    }
    enrichTemperatures(data) {
        if (data.temp) {
            data.temp_inlet = Math.round(data.temp.inlet);
            data.temp_outlet = Math.round(data.temp.outlet);
        }
        else {
            data.temp_inlet = '';
            data.temp_outlet = '';
        }
    }
    formatDeviceData(ip, id, props) {
        const ipNum = props.ipNum || Utils.IPtoNum(ip);
        const data = {
            id,
            ip,
            ipNum,
            dataType: props.infoApp ? 'infoApp' : props.columns ? 'columns' : '',
            ...(props.infoApp || props.columns || {})
        };
        this.enrichHostname(data, props);
        this.enrichPools(data);
        this.enrichTemperatures(data);
        if (data.runing_time) {
            data.running_time = data.runing_time; // Возможная ошибка: исправить опечатку `runing_time`.
        }
        return data;
    }
    updateFilters(devices, key, selectedKey) {
        const uniqueValues = [...new Set(devices.map((item) => item[key]).filter(Boolean))].sort();
        this.$q.store.farm[key + 's'] = uniqueValues;
        if (this.$q.store.farm[selectedKey] !== null &&
            !uniqueValues.includes(this.$q.store.farm[selectedKey])) {
            this.$q.store.farm[selectedKey] = null;
        }
    }
    applySorting(devices, sortBy, sortDir) {
        return devices.sort((a, b) => {
            const column = sortBy === 'ip' ? 'ipNum' : sortBy;
            if (a[column] < b[column])
                return sortDir === 'asc' ? -1 : 1;
            if (a[column] > b[column])
                return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
    }
    setTable(devices) {
        if (!devices) {
            return;
        }
        logger.log('setTable');
        let computedDevices = structuredClone(toRaw(devices));
        this.updateFilters(devices, 'miner_type', 'selectedMinerType');
        this.updateFilters(devices, 'miner_board_type', 'selectedBoardType');
        if (this.$q.store.farm.selectedMinerType) {
            computedDevices = computedDevices.filter((item) => item.miner_type === this.$q.store.farm.selectedMinerType);
        }
        if (this.$q.store.farm.selectedBoardType) {
            computedDevices = computedDevices.filter((item) => item.miner_board_type === this.$q.store.farm.selectedBoardType);
        }
        const { sortBy, sortDir } = this.$q.store.farm;
        computedDevices = this.applySorting(computedDevices, sortBy, sortDir);
        this.$q.store.farm.computedDevices = computedDevices;
    }
}
export default DeviceClass;
